export const QuickStats = ({ stats }) => {
  return (
    <div 
      className="flex items-center gap-6 bg-white rounded-xl px-4 py-2 shadow-sm border border-slate-100"
      data-testid="quick-stats"
    >
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500 font-medium">ROAS</span>
        <span className="text-sm font-bold text-slate-800" data-testid="roas-value">
          {stats?.roas?.value || '4.2x'}
        </span>
        <span 
          className={`text-xs font-semibold ${
            stats?.roas?.changeType === 'positive' ? 'text-emerald-500' : 'text-red-500'
          }`}
          data-testid="roas-change"
        >
          {stats?.roas?.change || '+0.7x'}
        </span>
      </div>
      <div className="h-6 w-px bg-slate-200" />
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-500 font-medium">CPL</span>
        <span className="text-sm font-bold text-slate-800" data-testid="cpl-value">
          {stats?.cpl?.value || '$28'}
        </span>
        <span 
          className={`text-xs font-semibold ${
            stats?.cpl?.changeType === 'positive' ? 'text-emerald-500' : 'text-red-500'
          }`}
          data-testid="cpl-change"
        >
          {stats?.cpl?.change || '-12%'}
        </span>
      </div>
    </div>
  );
};

export default QuickStats;
